const SingleOptionSetSingleAnswer = ({ data, question }) => {
  const optionSetKey = question.question_version > 1 ? 'option-set' : 'key';
  const optionKey = question.question_version > 1 ? 'option' : 'value';

  const optionSet = question.question_data.questions.filter(
    question => question[optionSetKey] === data[0][optionSetKey]
  )[0];

  if (!optionSet) return null;

  console.log('optionSet', optionSet);

  const entryOption = optionSet.options.filter(
    option => option.key === data[0][optionKey]
  );

  return entryOption[0] ? entryOption[0].title : null;
};

export default SingleOptionSetSingleAnswer;
